import { render } from "./importExcel.vue?vue&type=template&id=63471f03&scoped=true"
import script from "./importExcel.vue?vue&type=script&lang=js"
export * from "./importExcel.vue?vue&type=script&lang=js"

import "./importExcel.vue?vue&type=style&index=0&id=63471f03&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63471f03"]])

export default __exports__